import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, Divider, FormControlLabel, FormGroup, Grid, Hidden, Skeleton, Theme, Typography, useTheme } from "@mui/material"
import BreadCrum from "../../../../lib/BreadCrum"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router"
import { MpowerValidationType, SwitchNavigationProps } from "../../types"
import { RootStateType } from "../../../../redux-store/reducers"
import { getMandateCreationDetails, setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo } from "../../../../redux-store/actions/investorProfile"
import { BluePlusIcon, CheckIcon, EmailIcon, FailureIcon, OrangePlusIcon, Phoneicon, UnCheckIcon } from "../../../../assets/SvgIcons"
import { applicantStatusMasters, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MAX_SCHEMES_SELECTED, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES, WEEKLYDAYS } from "../../../../utils/constant"
import { CustomeButton } from "../../../../lib/formik/NewFormInputs"
import ConfirmRecomment from "../../common/ConfirmRecomment"
import RiskProfilePopup from "../../common/RiskProfilePopup"
import AddtoCardPopup from "../../common/AddtoCardPopup"
import SuccessModal from "../../common/SuccessModal"
import FiveSchemeErrorMessage from "../common/FiveSchemeErrorMessage"
import ValidateDialogBox from "../common/ValidateDialogBox"
import { getAbbreviatedName, isOnboardingTypeMinor, isRMLikeRole, maskInfo, toINR } from "../../../../utils/utilityFunctions"
import { useEffect, useRef, useState } from "react"
import { FrequencyArray, GETINVESTMENTDETAILTYPE, GetInvestmentUserDetails } from "../../../../redux-store/types/api-types"
import { FieldArray, Form, Formik, FormikProps, FormikValues, useFormik } from "formik"
import { MandateCreation } from "../../../../redux-store/types/investorProfile"
import * as Yup from 'yup';
import dayjs from "dayjs"
import Card from "./Card"
import { getInvestmentDetails, getInvestmentUserDetails, getRiskProfileCheck, submitInvestmentDetails, submitRecomment } from "../../../../redux-store/actions/funds"
import { addToCart, getCartItemsCount, setCartItemsCount } from "../../../../redux-store/actions/cart"
import { AddToCartResponseBody, GetCartItemsCountResponseBody } from "../../../../redux-store/types/cart"
import TransactionsDocumentUpload from "../../../../lib/TransactionsDocumentUpload"
import HoldingFundMore from "../../common/HoldingFundMore"
import { HoldingsTableData } from "../holdings/types"
import { TransactionsDisclaimer, TransactionsDisclaimerText } from "../../../ApplicationDetails/TermsAndConditions"


const swpSchema = (documentValidationSchema = {}) => {
    // const daily = validation?.filter((item) => item?.frequency === 'DAILY')?.[0]
    // const weekly = validation?.filter((item) => item?.frequency === 'WEEKLY')?.[0]
    // const weeklyDays = validation?.filter((item) => item?.frequency === 'WEEKLYDAYS')?.[0]
    // const monthly = validation?.filter((item) => item?.frequency === 'MONTHLY')?.[0]
    // const quarterly = validation?.filter((item) => item?.frequency === 'QUARTERLY')?.[0]
    // const yearly = validation?.filter((item) => item?.frequency === 'YEARLY')?.[0]

    // const commonValidation = (frequency: string) => validation?.filter((item) => item?.frequency === frequency)?.[0]


    return Yup.object().shape({
        fund: Yup.lazy((_value) => {
            const getFrequency = (index: number) => {
                const swpValidations = _value?.[index]?.investmentDetails?.validations?.filter((item: MpowerValidationType) => item?.transactionType === 'SWP');
                const finalSwpValidation = swpValidations?.find((v: any) => v.frequency === _value?.[index]?.frequency);
                return finalSwpValidation;
            }

            return Yup.array().of(
                Yup.object().shape({
                    frequency: Yup.string().required('Frequency is Required'),
                    // amount: Yup
                    // .number().required('SWP Amount is Required').
                    // when('frequency', {
                    //     is: "DAILY",
                    //     then: Yup.number().min(daily?.minimumInstallmentAmount, `Minimum amount ${daily?.minimumInstallmentAmount}`)
                    // }).when('frequency', {
                    //     is: "WEEKLY",
                    //     then: Yup.number().min(weekly?.minimumInstallmentAmount, `Minimum amount ${weekly?.minimumInstallmentAmount}`)
                    // }).when('frequency', {
                    //     is: "MONTHLY",
                    //     then: Yup.number().min(monthly?.minimumInstallmentAmount, `Minimum amount ${monthly?.minimumInstallmentAmount}`)
                    // }).when('frequency', {
                    //     is: "QUARTERLY",
                    //     then: Yup.number().min(quarterly?.minimumInstallmentAmount, `Minimum amount ${quarterly?.minimumInstallmentAmount}`)
                    // }).when('frequency', {
                    //     is: "YEARLY",
                    //     then: Yup.number().min(yearly?.minimumInstallmentAmount, `Minimum amount ${yearly?.minimumInstallmentAmount}`)
                    // }).when('frequency', {
                    //     is: "WEEKLYDAYS",
                    //     then: Yup.number().min(weeklyDays?.minimumInstallmentAmount, `Minimum amount ${weeklyDays?.minimumInstallmentAmount}`)
                    // }),
                    amount: Yup.string()
                        .test("min-amount", function (value, context) {
                            const { createError, path } = context;
                            const index = Number(path.match(/[\d,]+/g)?.[0])

                            const minimumInstallmentAmount = getFrequency(index)?.minimumInstallmentAmount

                            if (!`${value ?? ""}`.length) {
                                return createError({ path, message: 'Amount is required' })
                            }
                            if (Number.isNaN(Number(value))) {
                                return createError({ path, message: 'Invalid number' })
                            }
                            if (Number(value) < Number(minimumInstallmentAmount ?? "")) {
                                return createError({
                                    message: `Minimum amount ${minimumInstallmentAmount}`,
                                });
                            }
                            return true;
                        }),
                    swpDate: Yup.date()
                        .typeError('Invalid date')
                        .min(dayjs().add(-1, 'day'), 'Past date are not allowed')
                        .required('SWP Date is Required')
                        .test(
                            'frequency', (value, context) => {
                                const { path, createError } = context
                                const { frequency } = context.parent

                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                // For past date
                                if ((dayjs(new Date()).isAfter(value, 'day'))) {
                                    return createError({ path, message: 'Past date is not allowed' });
                                }
                                // For T+1 date
                                if ((dayjs(new Date()).add(1, 'day').isAfter(value, 'day'))) {
                                    return createError({ path, message: 'Date should be T+1' });
                                }

                                // const validation = commonValidation(frequency)
                                const validationCheck = getFrequency(index);
                                // const valid = handleDateValidation(finalSwpValidation?.investmentDates, dayjs(value))
                                const valid = handleDateValidation(getFrequency(index)?.investmentDates, dayjs(value))
                                if (valid) {
                                    return createError({
                                        // message: `Only ${validation?.investmentDates.join(', ')} are allowed`,
                                        message: `Only ${validationCheck?.investmentDates.join(', ')} are allowed`,
                                        path
                                    })
                                }
                                return true
                            }
                        ),
                    // installment: Yup.number().required('Installment is Required').when('frequency', {
                    //     is: "DAILY",
                    //     then: Yup.number().min(daily?.minimumInstallments, `Minimum ${daily?.minimumInstallments}`)
                    // }).when('frequency', {
                    //     is: "WEEKLY",
                    //     then: Yup.number().min(weekly?.minimumInstallments, `Minimum ${weekly?.minimumInstallments}`)
                    // }).when('frequency', {
                    //     is: "MONTHLY",
                    //     then: Yup.number().min(monthly?.minimumInstallments, `Minimum ${monthly?.minimumInstallments}`)
                    // }).when('frequency', {
                    //     is: "QUARTERLY",
                    //     then: Yup.number().min(quarterly?.minimumInstallments, `Minimum ${quarterly?.minimumInstallments}`)
                    // }).when('frequency', {
                    //     is: "YEARLY",
                    //     then: Yup.number().min(yearly?.minimumInstallments, `Minimum ${yearly?.minimumInstallments}`)
                    // }).when('frequency', {
                    //     is: "WEEKLYDAYS",
                    //     then: Yup.number().min(weeklyDays?.minimumInstallments, `Minimum ${weeklyDays?.minimumInstallments}`)
                    // }),
                    installment: Yup
                        .string()
                        .test("min-installment", function (value, context) {
                            const { createError, path } = context;
                            const index = Number(path.match(/[\d,]+/g)?.[0])

                            const minimumInstallments = getFrequency(index)?.minimumInstallments

                            if (!`${value ?? ""}`.length) {
                                return createError({ path, message: 'Installment is required' })
                            }
                            if (Number.isNaN(Number(value))) {
                                return createError({ path, message: 'Invalid number' })
                            }
                            if (Number(value) < Number(minimumInstallments ?? "")) {
                                return createError({
                                    message: `Minimum installments ${minimumInstallments}`,
                                });
                            }
                            return true;
                        }),
                    bankType: Yup.string().required('Bank is Required'),
                })
            )
        }),
        ...documentValidationSchema
    })
};


export const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}


const Swp = () => {
    const { palette, typography } = useTheme()
    const dispatch = useDispatch()
    const history = useHistory()
    const { pathname, state } = history.location
    const navState = state as SwitchNavigationProps
    const { selectedSchemes = [], clientCode, folio = [], schemeDetails = [] } = (state as { selectedSchemes?: string[], clientCode: string, folio?: { folioId?: string, schemeId?: string, marketValue: number, investedValue: number, id: string }[], schemeDetails?: { scheme_id: string, isReinvestment: string }[] }) ?? []

    const formRef = useRef<FormikProps<any>>(null);

    const {
        selectedPortfolio,
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const {
        selectAllHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);
    const {
        iwappRmId = "",
        clientInterfaceCode,
        familyMemberId = ""
    } = useSelector((store: RootStateType) => store.id);
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData);
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    //state
    const [details, setDetails] = useState<GETINVESTMENTDETAILTYPE>({} as GETINVESTMENTDETAILTYPE)
    const [isLoading, setIsLoading] = useState(false)
    const [isUserLoading, setIsUserLoading] = useState(false)
    const [confirmRecomment, setConfirmRecomment] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [userDetails, setUserDetails] = useState<GetInvestmentUserDetails>({} as GetInvestmentUserDetails);
    const [schemeLoading, setSchemeLoading] = useState(false)
    const [orderType, setOrderType] = useState<'order' | 'recomment' | 'investor'>('order');
    const [apiLoading, setApiLoading] = useState(false);
    const [cartPopup, setCartPopup] = useState<boolean>(false);
    const [submit, setSubmit] = useState<FormikValues>({});
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])
    const [bankDetails, setBankDetails] = useState<Array<MandateCreation>>([] as Array<MandateCreation>);
    const [addtoCartLoading, setAddtoCartLoading] = useState<boolean>(false);
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);
    const [initialValues, setInitialValues] = useState<FormikValues>({
        fund: [
            {
                amount: '',
                frequency: '',
                swpDate: '',
                installment: '',
                bankType: '',
                firstOrder: false
            }
        ],
        ...((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            isRMLikeRole(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: [{
                documentId: "",
                documentType: ""
            }]
        } : {})
    })
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);
    const [recommendPlaceOrderResponse, setRecommendPlaceOrderResponse] = useState<any>({})
    const [isAddMoreHoldingDialogOpen, setAddMoreHoldingDialogOpen] = useState<boolean>(false)
    const [holdingsData, setHoldingsData] = useState<HoldingsTableData[]>([])
    const [isSameSchemesDialogOpen, setSameSchemesDialogOpen] = useState<boolean>(false)
    const [disclaimerChecked, setDisclaimerChecked] = useState<boolean>(false);
    const [isTxnDialog, setIsTxnDialog] = useState<boolean>(false);

    const mfTxnStatus = userDetails?.application?.bseClientActivationStatus?.toLowerCase() !== 'active'

    const isMinor = isOnboardingTypeMinor(userDetails?.application?.onboardingType || '');
    const investorName = isMinor ? `${userDetails?.application?.applicants?.[0]?.minorFirstName} ${userDetails?.application?.applicants?.[0]?.minorLastName}` : userDetails?.name;

    // const frequencyArray = details?.investmentDetails?.[0].frequencies.filter(item => item.tranasactionType === 'SWP' && item.frequency)
    // const validation = details?.investmentDetails?.[0].validations.filter(item => item.transactionType === "SWP")

    const documentValidationSchema = ((
        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
        isRMLikeRole(role) &&
        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
    ) ? {
        documents: Yup.array().of(
            Yup.object().shape({
                documentId: Yup.string(),
                documentType: Yup.string()
            })
        )
    } : {})

    // const scheme = swpSchema(validation, frequencyArray, documentValidationSchema)
    const scheme = swpSchema(documentValidationSchema)

    // useEffect(() => {
    //     const fetchAll = async () => {
    //         getValidation(navState?.itemData?.schemeId)
    //     }
    //     if (navState?.itemData?.schemeId) fetchAll()
    //     if (navState.clientCode) {
    //         Promise.all([getBankDetails(), getUserData()])
    //     }
    // }, [navState])
    useEffect(() => {
        getValidation();
        Promise.all([getBankDetails(), getUserData()])
    }, [clientCode])

    const getBankDetails = async () => {
        setIsLoading(true)
        const bankDetailsRes = (await dispatch(getMandateCreationDetails({ clientCode, portfolioId: selectedPortfolio?.value }))) as unknown as any

        setBankDetails(bankDetailsRes);
        setIsLoading(false)
    }

    const onDisclaimerCheck = () => {
        setDisclaimerChecked(!disclaimerChecked);
    }

    const getUserData = async () => {

        setIsUserLoading(true)
        if (clientCode) {
            const res1 = (await dispatch(getInvestmentUserDetails({ clientCode, portfolioId: selectedPortfolio?.value }))) as unknown | GetInvestmentUserDetails;
            setUserDetails(res1 as GetInvestmentUserDetails);
        }
        // setDetails(res1 as GETSWITCHDETAILTYPE)
        setIsUserLoading(false)
    }

    const getValidation = async () => {
        if (!(selectedSchemes ?? []).length) {
            setIsLoading(false)

            formRef.current?.resetForm({
                values: {
                    ...(formRef.current?.values ?? {}),
                    fund: [],
                }
            })

            return
        }

        setSchemeLoading(true);
        const payload = {
            // schemeIds: [shemeId],
            // portfolioId: selectedPortfolio?.value,
            // clientCode: navState.clientCode,
            // rmId: `${investorRmId}`,
            // schemeDetails: navState?.schemeDetails ?? []
            schemeIds: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item),
            portfolioId: selectedPortfolio?.value,
            clientCode: clientCode,
            rmId: `${investorRmId}`,
            schemeDetails: selectedSchemes?.map((obj: any) => ({
                scheme_id: obj?.scheme ?? "",
                isReinvestment: obj?.isReinvestment ? obj?.isReinvestment : obj?.divReinvestAllowed ?? "",
            }))
        }
        const res = ((await dispatch(getInvestmentDetails(payload))) as unknown) as GETINVESTMENTDETAILTYPE;
        setDetails(res as GETINVESTMENTDETAILTYPE);
        // const frequencyArray = res?.investmentDetails?.[0].frequencies.filter(item => item.tranasactionType === 'SWP' && item.frequency)
        const freqArray = res?.investmentDetails?.map(freq => freq.frequencies.filter(item => item.transactionType === 'SWP' && item.frequency))

        formRef.current?.resetForm({
            values: {
                fund: [...((res as GETINVESTMENTDETAILTYPE)?.investmentDetails || [])]?.map((item, ind) => ({
                    amount: '',
                    frequency: freqArray[ind]?.[0]?.frequency || '',
                    swpDate: '',
                    installment: '',
                    bankType: '',
                    selectedSchemeDetails: selectedSchemes?.[ind],
                    investmentDetails: item,
                    folio: folio[ind],
                    firstOrder: false
                })),
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    isRMLikeRole(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: formRef.current?.values?.documents ?? []
                } : {})
            }
        })

        setSchemeLoading(false)
    }

    const hasDuplicateSchemes = (arr: any) => {
        const codeSet = new Set();

        for (const item of arr) {
            const key = `${item.isinCode}-${item.folioNo}`;
            if (codeSet.has(key)) {
                return true;
            }
            codeSet.add(key);
        }

        return false;
    }

    const handleSameSchemeDialogClose = () => {
        setSameSchemesDialogOpen(false)
    }

    const handleSameSchemeDialogConfirm = async () => {
        handleSameSchemeDialogClose()

        if (!formRef.current) {
            return
        }

        const { values } = formRef.current

        setSubmit(values);
        if (orderType === 'investor') {
            setApiLoading(true)
            try {
                setAddtoCartLoading(true);
                const payload = (values?.fund ?? []).map((obj: FormikValues) => ({
                    // "aumAmount": values.amount,
                    "trType": "SWP",
                    isDividendReinvestment: obj?.investmentDetails?.divReinvestAllowed ?? "",
                    mPowerScheme: obj?.investmentDetails?.mPowerScheme ?? "",
                    "categoryName": obj?.selectedSchemeDetails?.categoryName ?? "",
                    "clientCode": clientInterfaceCode ? clientInterfaceCode : clientCode,
                    "exitLoad": obj?.investmentDetails?.detailsList?.[3].value,
                    "navValue": `${obj?.selectedSchemeDetails?.navValue ?? ""}`,
                    "frequency": obj?.frequency ?? "",
                    "amount": obj?.amount ?? '',
                    "riskType": obj?.selectedSchemeDetails?.riskType ?? "",
                    "schemeId": obj?.investmentDetails?.schemeId ?? "",
                    "schemeName": obj?.selectedSchemeDetails?.schemeName ?? "",
                    "subCategoryName": obj?.selectedSchemeDetails?.subCategoryName ?? "",
                    "y3Returns": obj?.investmentDetails?.detailsList?.[2].value,
                    "noOfInstallment": obj?.installment,
                    "mandateId": '',
                    "sipDate": obj?.swpDate ? dayjs(obj?.swpDate).format("DD/MM/YYYY") : "",
                    "navDate": obj?.selectedSchemeDetails?.navDate ?? "",
                    "folioNo": obj?.selectedSchemeDetails?.folioNo ?? "",
                    "portfolioId": selectedPortfolio?.value,
                    investedValue: `${obj?.selectedSchemeDetails?.investedValue ?? ""}`,
                    marketValue: `${obj?.selectedSchemeDetails?.marketValue ?? ""}`,
                    transMode: 'A',
                    bankName: bankDetails?.filter(item => item?.bankAccountNumber === obj.bankType)?.[0]?.bankName,
                    bankAccountNumber: obj?.bankType,
                    amcId: obj?.selectedSchemeDetails?.amcId ?? "",
                    rmId: `${investorRmId}`,
                    firstOrderFlag: obj?.firstOrder ? "Y" : "N",
                }))

                const res = ((await dispatch(addToCart(payload as any))) as unknown) as AddToCartResponseBody;
                if (res.isSuccess) {
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : navState.clientCode,
                        portfolioId: selectedPortfolio?.value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                        dispatch(setSelectedHoldingsInfo([]))
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }

                    setCartPopup(true)
                } else if (!res.isSuccess) {
                    if (res.message) {
                        setFiveSchemesDialogVisible(true)
                    } else {
                        setValidationErrorsArray(
                            res.response
                                .filter(data => !data.isSuccess)
                                .map(data => ({
                                    schemeName: data.schemeName,
                                    errorMessage: data.message
                                }))
                        )
                        setValidationDialogVisible(true)
                    }
                }
                setAddtoCartLoading(false);
            } catch (err) {
                console.log(err)
            }
            setApiLoading(false)
        } else {
            if (orderType === 'order') {
                try {
                    setRiskPflChkLoading(true)
                    const riskProfileCheckRes = (await dispatch(getRiskProfileCheck({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : navState.clientCode,
                        // schemeCode: [navState.itemData.schemeId]
                        schemeCode: (formRef?.current?.values?.fund ?? []).map((obj: FormikValues) => obj?.selectedSchemeDetails?.schemeId)
                    }))) as unknown as {
                        isSuccess: boolean,
                        displayText: string
                    }

                    if (!riskProfileCheckRes?.isSuccess) {
                        setRiskProfilePopup(true)
                        setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                    } else {
                        // setConfirmRecomment(true)
                        handleConformOrder(values)
                    }
                } catch (e) {
                    console.log(e);
                }
                finally {
                    setRiskPflChkLoading(false)
                }

            } else {
                setConfirmRecomment(true)
            }
        }
    }


    const onSubmit = async (values: FormikValues) => {
        if ((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            isRMLikeRole(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        )) {
            if (values?.documents?.length === 1 && (values?.documents[0]?.documentId === '' || values?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return
            }
        }

        // Checking if multiple orders with the same scheme/folio combination are there ot not

        const hasDuplicates = hasDuplicateSchemes(
            (values?.fund ?? [])?.map((obj: any) => ({ ...(obj?.selectedSchemeDetails ?? {}) }))
        )

        if (hasDuplicates) {
            setSameSchemesDialogOpen(true)
            return
        } else {
            handleSameSchemeDialogConfirm()
        }
    }

    const handleConfromRecomment = async (values: FormikValues) => {
        setApiLoading(true)
        const payload = (values?.fund ?? []).map((obj: FormikValues) => ({
            clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
            amcId: obj?.investmentDetails?.fundAmcId ?? "",
            schemeId: obj?.investmentDetails?.schemeId ?? "",
            buySellType: 'SWP',
            schemeName: obj?.investmentDetails?.fundName ?? "",
            categoryName: obj?.investmentDetails?.fundType ?? "",
            subCategoryName: obj?.investmentDetails?.fundCap ?? "",
            riskType: obj?.investmentDetails?.riskType ?? "",
            navDate: obj?.selectedSchemeDetails?.navDate ?? "",
            navValue: obj?.selectedSchemeDetails?.navValue ?? "",
            folioNo: obj?.selectedSchemeDetails?.folioNo ?? "",
            // accountType: formik.values.bankType,
            recommendedAmount: `${obj?.amount}`,
            frequency: obj?.frequency,
            noOfInstallments: `${obj?.installment}`,
            systematicDate: obj?.swpDate ? dayjs(obj?.swpDate).format("DD/MM/YYYY") : "",
            recommendedDate: dayjs().format("DD/MM/YYYY"),
            imgUrl: '',
            bankName: bankDetails.filter(item => item.bankAccountNumber === obj.bankType)[0]?.bankName,
            email: userDetails.email,
            mobileNo: userDetails.mobile,
            bankAccountNumber: obj?.bankType,
            portfolioId: selectedPortfolio?.value,
            investedValue: `${obj?.selectedSchemeDetails?.investedValue ?? ""}`,
            marketValue: `${obj?.selectedSchemeDetails?.marketValue ?? ""}`,
            rmId: `${investorRmId}`,
            firstOrderFlag: obj?.firstOrder ? "Y" : "N",
        }))


        const res = (await dispatch(submitRecomment(payload))) as unknown as {
            isSuccess: boolean,
            message: string,
            response: Array<any>
        };

        if (res.isSuccess) {
            setRecommendPlaceOrderResponse(res)

            setConfirmRecomment(false)
            dispatch(setSelectedHoldingsIds([]))
            dispatch(setCheckedHoldingSchemes([]))
            dispatch(setSelectedHoldingsInfo([]))
            dispatch(setSelectedAllHoldingsInfo([]))
            setSuccessModal(true);
        } else if (!res.isSuccess) {
            setConfirmRecomment(false)
            if (res.message) {
                setFiveSchemesDialogVisible(true)
            } else {
                setValidationErrorsArray(
                    res.response
                        .filter(data => !data.isSuccess)
                        .map(data => ({
                            schemeName: data.schemeName,
                            errorMessage: data.message
                        }))
                )
                setValidationDialogVisible(true)
            }
        }

        setApiLoading(false);
    }

    const handleConformOrder = async (values: FormikValues) => {
        setApiLoading(true)

        const payload = (values?.fund ?? []).map((obj: FormikValues) => {
            return {
                "clientCode": clientInterfaceCode ? clientInterfaceCode : clientCode,
                "portfolioId": selectedPortfolio?.value,
                portfolioName: selectedPortfolio?.label,
                "fromScheme": obj?.selectedSchemeDetails?.scheme ?? "",
                "trType": "SWP",
                "folio": obj?.selectedSchemeDetails?.folioNo ?? "",
                "amount": obj?.amount,
                "transactionStartDate": obj?.swpDate ? dayjs(obj?.swpDate).format("DD/MM/YYYY") : "",
                "frequency": obj?.frequency,
                "noOfWithdrawls": `${obj?.installment}`,
                "mobile": `${userDetails.mobile}`,
                "email": `${userDetails.email}`,
                "schemeName": obj?.selectedSchemeDetails?.schemeName ?? "",
                "bankAccountNumber": obj?.bankType,
                "rmId": `${investorRmId}`,
                "isRecommended": isRMLikeRole(role) ? true : false,
                "isDiy": isRMLikeRole(role) ? false : true,
                amcId: obj?.investmentDetails?.fundAmcId ?? "",
                "cartId": null,
                firstOrderFlag: obj?.firstOrder ? "Y" : "N",
            }
        })
        try {
            const res = (await dispatch(submitInvestmentDetails({
                accountType: selectedPortfolioObj?.portfolioAccountType,
                orderDetails: payload,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    isRMLikeRole(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: values?.documents?.filter((obj: {
                        documentId: string;
                        documentType: string;
                    }) => obj.documentId !== "" && obj.documentType !== "")
                } : {})
            }))) as unknown as {
                isSuccess: boolean,
                message: string,
                ordersValidation: Array<any>
                isPaymentFlow?: boolean
                token?: string
                cartId?: string
                otp_response?: any
            };

            if (res?.isSuccess) {
                if (role === USER_ROLES.INVESTOR) {
                    if (res?.isPaymentFlow) {
                        history.push(`/cart/verify-otp`, {
                            token: res?.token ?? "",
                            cartId: res?.cartId ?? "",
                            id: res?.otp_response?.id ?? "",
                            otpMessage: res?.otp_response?.message ?? "",
                        })
                    }
                }
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res.message) {
                    setFiveSchemesDialogVisible(true)
                } else {
                    setValidationErrorsArray(
                        res.ordersValidation
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }

        } catch (err) {
            console.log('err', err)
        }
        setConfirmRecomment(false);
        setRiskProfilePopup(false);
        setApiLoading(false)

    };

    const handleSuccess = () => {
        history.push('/cart', { clientCode: navState.clientCode })
    }



    const handleSuccessPopup = () => {
        // dispatch(setAppliedFundsFilters([]));
        // dispatch(setSelectedSchemesObj({}));
        // history.goBack()
        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
    }

    const handleCloseFiveSchemesDialog = () => {
        setFiveSchemesDialogVisible(false)
    }

    const handleValidationDialogClose = () => {
        setValidationDialogVisible(false)
    }

    const handleRiskProfilePopup = (btnText: string) => {
        setRiskProfilePopup(false);

        if (btnText === 'continue') {
            setConfirmRecomment(true);
        }
    }

    const handleDelete = (checkId: string, selectedUniqueId: string) => {
        setDetails((pre: GETINVESTMENTDETAILTYPE) => {
            const result = pre?.investmentDetails?.filter((item) => item?.schemeId !== checkId);

            // const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.id !== checkId);
            const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.uniqueId !== selectedUniqueId);

            history.replace({
                state: ({
                    selectedSchemes: modifiedSelectedSchemes,
                    clientCode,
                    // schemeDetails: modifiedSelectedSchemes,
                    schemeDetails: (modifiedSelectedSchemes ?? [])
                        .map((item: any) => ({
                            scheme_id: item?.schemeId ?? "-",
                            isReinvestment: item?.isReinvest ?? "-"
                        })),
                    // folio: modifiedSelectedSchemes,
                    folio: (modifiedSelectedSchemes ?? [])
                        .map((item: any) => ({
                            folioId: item.folioId,
                            id: item.id,
                            investedValue: item.investedValue,
                            marketValue: item.marketValue,
                            schemeId: item.scheme,
                        })),
                })
            })

            return { ...pre, result };
        })
    }

    const addFunds = async (schemes: any, addedFolio?: any) => {

        // schemes currently in formik
        const currentSchemesArr = (formRef.current?.values?.fund ?? []).map((obj: any) => obj.selectedSchemeDetails)

        // latest added schemes excluding the schemes in formik
        const latestAddedSchemes = schemes?.filter((obj: any) => !currentSchemesArr.find((currObj: any) => currObj.uniqueId === obj.uniqueId))

        if (!(latestAddedSchemes ?? []).length) {
            return
        }

        try {
            setIsLoading(true);
            const payload = {
                // passing only those schemeIds which have been added via Add more funds, NOT passing those schemes already in Formik
                // schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
                schemeIds: (latestAddedSchemes ?? [])?.map((item: any) => item?.scheme ?? ""),
                portfolioId: selectedPortfolio?.value,
                clientCode: clientCode,
                rmId: `${investorRmId}`,
                // schemeDetails: Object.values(schemes)?.map((obj: any) => ({
                //     scheme_id: obj?.scheme ?? "",
                //     isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                // }))
                schemeDetails: (latestAddedSchemes ?? [])?.map((obj: any) => ({
                    scheme_id: obj?.scheme ?? "",
                    isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                }))
            }


            const res = ((await dispatch(getInvestmentDetails(payload))) as unknown) as GETINVESTMENTDETAILTYPE;
            setDetails(res as GETINVESTMENTDETAILTYPE);

            const frequencyArray = res?.investmentDetails?.map(freq => freq.frequencies.filter(item => item.transactionType === 'SWP' && item.frequency))

            // extracting ISIN codes from the response
            const responseIsinCodes = ((res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []).map((item: any) => item.isinCode) as Array<string>

            // Filtering out those schemes for which we did not get the api response based on the isin code
            const modifiedLatestAddedSchemes = latestAddedSchemes.filter((item: any) => responseIsinCodes.includes(item.isinCode));

            const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {
                const addedFolio = {
                    folioId: modifiedLatestAddedSchemes[i].folioId,
                    id: modifiedLatestAddedSchemes[i].id,
                    investedValue: modifiedLatestAddedSchemes[i].investedValue,
                    marketValue: modifiedLatestAddedSchemes[i].marketValue,
                    schemeId: modifiedLatestAddedSchemes[i].scheme,
                }

                return {
                    amount: '',
                    frequency: frequencyArray?.[i]?.[0]?.frequency || '',
                    swpDate: '',
                    installment: '',
                    bankType: '',
                    // selectedSchemeDetails: schemes?.[i],
                    selectedSchemeDetails: modifiedLatestAddedSchemes[i],
                    investmentDetails: item,
                    folio: addedFolio,
                    firstOrder: false,
                }
            })
            const currentForm = [...formRef.current?.values?.fund]
            // const newFrom = [...formInitial]

            // const getId = (item: any) => item?.map((obj: any) => obj.folio.id)

            // const currentSchemeId = getId([...currentForm])
            // const newSchemeId = getId([...newFrom])

            // const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.folio.id))
            // const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.folio.id))

            const updatedFundsArray = [...currentForm, ...formInitial]

            history.replace({
                state: ({
                    selectedSchemes: updatedFundsArray
                        .map(obj => obj?.selectedSchemeDetails ?? {})
                        .map(item => ({
                            ...item,
                            folioId: item.folioNo,
                            scheme: item.schemeId,
                            id: item.id,
                            marketValue: item.marketValue,
                            investedValue: item.investedValue,
                            isReinvestment: item?.isReinvest
                        })),
                    clientCode,
                    schemeDetails: updatedFundsArray
                        .map(obj => obj?.selectedSchemeDetails ?? {})
                        .map(item => ({
                            scheme_id: item?.schemeId ?? "-",
                            isReinvestment: item?.isReinvest ?? "-"
                        })),
                    folio: updatedFundsArray
                        .map(obj => obj?.selectedSchemeDetails ?? {})
                        .map(item => ({
                            folioId: item.folioId,
                            id: item.id,
                            investedValue: item.investedValue,
                            marketValue: item.marketValue,
                            schemeId: item.scheme,
                        }))
                })
            })

            dispatch(setSelectedHoldingsInfo(
                updatedFundsArray.map(obj => ({
                    checkedId: obj?.selectedSchemeDetails?.id,
                    schemeId: obj?.selectedSchemeDetails?.scheme,
                    folioNo: obj?.selectedSchemeDetails?.folioNo ?? "",
                    uniqueId: obj?.selectedSchemeDetails?.uniqueId
                }))))

            dispatch(setSelectedAllHoldingsInfo(
                updatedFundsArray.map(obj => obj?.selectedSchemeDetails ?? {})
            ))

            formRef.current?.resetForm({
                values: {
                    fund: updatedFundsArray,
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        isRMLikeRole(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: formRef.current?.values?.documents ?? []
                    } : {}),
                }
            })

        } catch (err) {
            console.log('error', err)
        } finally {
            setIsLoading(false)
        }
    };

    const handleProceed = () => {
        const data = selectAllHoldingsInfo.map(item => ({
            ...item,
            folioId: item.folioNo,
            scheme: item.schemeId,
            id: item.id,
            marketValue: item.marketValue,
            investedValue: item.investedValue,
            isReinvestment: item?.isReinvest
        }))

        const checkedIds = data.map((obj) => obj.scheme)

        const folioData = data.map((obj) => ({
            folioId: obj.folioId,
            schemeId: obj.scheme,
            id: obj.id,
            marketValue: obj.marketValue,
            investedValue: obj.investedValue
        }))

        const schemeDetails = selectAllHoldingsInfo?.map((obj) => ({
            scheme_id: obj?.schemeId ?? "-",
            isReinvestment: obj?.isReinvest ?? "-"
        }))

        dispatch(setSelectedHoldingsIds([...[]]))
        dispatch(setCheckedHoldingSchemes([...checkedIds]))

        // history.replace({
        //     state: ({
        //         selectedSchemes: [...data],
        //         clientCode,
        //         schemeDetails,
        //         folio: folioData
        //     })
        // })

        setAddMoreHoldingDialogOpen(false)

        addFunds([...data], folioData)
    }

    const TotalValue = () => {

        const values = formRef.current?.values?.fund ?? [];
        const totalAmount = values?.reduce((acc: number, curr: FormikValues) => {
            return acc + Number(curr?.amount ?? 0);
        }, 0)
        return totalAmount;
    }

    //Bread crum data
    const initialRouter = pathname?.split('/').filter((item) => item !== '')

    const rmRouterPath = [
        {
            name: 'Dashboard',
            path: '/dashboard',
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: navState.clientCode
            },
            warning: true,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Detailed Portfolio Holdings',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: navState.clientCode
            },
            search: "?tab=Holdings"
        },
        {
            name: "SWP",
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
            textSx: {
                textTransform: 'uppercase',
            }
        },
    ]

    const investorRouterPath = [
        ...(familyMemberId
            ?
            [{
                name: 'View Family',
                path: `/investor-family/family-profile/${familyMemberId}`,
            },
            {
                name: `${initialRouter[1]}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            }]
            :
            [
                {
                    name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
                    path: '/investor-dashboard',
                    warning: selectedSchemes?.length > 0,
                    handleClick: () => {
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }
                },
            ]
        ),
        {
            name: "swp",
            path: (familyMemberId ? `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}` : `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`),
            state: {
                clientCode: navState.clientCode
            },
            textSx: {
                textTransform: 'uppercase',
            }
        },
    ]

    const selectedBankDetails = (bankValue: string) => {
        const result = [...bankDetails].filter((item) => item.bankAccountNumber === bankValue)
        return result.length > 0 ? `${result?.[0]?.bankName}-${result?.[0]?.bankAccountNumber}` : "-"
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    let successMessage = ""

    if (orderType === 'recomment') {
        successMessage = "Your Recommendation is sent successfully to the Investor."
    } else {
        if (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && selectedPortfolioObj?.portfolioAccountType) {
            if (isRMLikeRole(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} sent to the checker for approval.`
            }
            if (isRMLikeRole(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["EXY"]
            ) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} successfully sent to the investor for approval. Once authorized and approved the order will be placed.`
            }
        } else {
            successMessage = "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."
        }

    }

    return <>
        <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />
        <Typography variant='h1' mt={2} color={palette.text.primary} fontSize={{ sm: '16px', xs: '16px', md: '24px', lg: '24px' }}>SWP (Systematic Withdrawal Plan)</Typography>
        <Formik
            // initialValues={initialValues}
            initialValues={{
                fund: [
                    {
                        amount: '',
                        frequency: '',
                        swpDate: '',
                        installment: '',
                        bankType: '',
                        firstOrder: false,
                    }
                ],
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    isRMLikeRole(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: [{
                        documentId: "",
                        documentType: ""
                    }]
                } : {})
            }}
            validationSchema={scheme}
            innerRef={formRef}
            onSubmit={onSubmit}
        // enableReinitialize
        >
            {({ values, handleReset, handleSubmit, errors, dirty }) => {
                return (
                    <>
                        <Box component={'form'} onReset={handleReset} onSubmit={handleSubmit}>
                            <Grid container marginTop={2} spacing={2}>
                                <Grid
                                    item
                                    lg={8}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                        display: 'flex',
                                        rowGap: '25px',
                                        flexDirection: 'column'
                                    }}>
                                    <>
                                        {(values?.fund ?? []).map((obj: FormikValues, index: number) => (
                                            <Card
                                                key={index}
                                                isSubmitting={apiLoading}
                                                isLoading={schemeLoading}
                                                data={obj?.investmentDetails}
                                                clientCode={clientCode}
                                                itemData={{
                                                    units: obj?.selectedSchemeDetails?.units,
                                                    folioNo: obj?.selectedSchemeDetails?.folioNo,
                                                    navDate: obj?.selectedSchemeDetails?.navDate,
                                                    navValue: obj?.selectedSchemeDetails?.navValue,
                                                    balanceAmount: obj?.selectedSchemeDetails?.balanceAmount,
                                                    availableUnits: obj?.selectedSchemeDetails?.availableUnits
                                                }}
                                                bankList={bankDetails}
                                                navState={{ itemData: selectedSchemes[index] }}
                                                id={index}
                                                folio={obj.folio}
                                                handleDelete={handleDelete}
                                            // {...{ isLoading: schemeLoading, id: index, data: details?.investmentDetails?.[0], navState: navState, bankList: bankDetails, isSubmitting: apiLoading }}
                                            />
                                        ))}
                                        {selectedSchemes.length < MAX_SCHEMES_SELECTED && (
                                            <Box
                                                sx={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                {isLoading && (
                                                    <Skeleton
                                                        variant="rectangular"
                                                        width={200}
                                                        height={30}
                                                    />
                                                )}
                                                {!isLoading && (
                                                    <Button
                                                        variant="text"
                                                        onClick={() => setAddMoreHoldingDialogOpen(true)}
                                                        sx={{
                                                            gap: '10px',
                                                            '&:hover': {
                                                                background: 'transparent',
                                                            },
                                                            '&:disabled': {
                                                                opacity: 0.5
                                                            }
                                                        }}
                                                        disabled={apiLoading}
                                                    >
                                                        <OrangePlusIcon />
                                                        <Typography
                                                            variant="body_500"
                                                            color={palette.text.secondary}
                                                            sx={{
                                                                textDecoration: 'dashed',
                                                                textDecorationColor: palette.primary[500],
                                                                textDecorationThickness: '2px',
                                                            }}
                                                        >
                                                            Add More Holding
                                                        </Typography>
                                                    </Button>
                                                )}
                                            </Box>
                                        )}
                                    </>
                                </Grid>
                                <Grid item lg={4} md={12} sm={12} xs={12}>
                                    {(
                                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                        isRMLikeRole(role) &&
                                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                    ) && (
                                            <Box
                                                sx={{
                                                    background: palette.background.paper,
                                                    padding: '20px',
                                                    borderRadius: '20px',
                                                    marginBottom: "20px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexDirection: "column"
                                                }}
                                                boxShadow={1}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={{
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: `${palette.text.secondary}B2`,
                                                    }}
                                                >
                                                    You can add minimum 1 attachment and maximum 5 attachments
                                                </Typography>
                                                <Typography
                                                    variant='body_400'
                                                    sx={{
                                                        color: palette.text.primary,
                                                        alignSelf: "flex-start",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    Documents Uploaded: {
                                                        values?.documents?.filter((obj: {
                                                            documentId: string;
                                                            documentType: string;
                                                        }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                    }
                                                </Typography>
                                                <Button
                                                    sx={{
                                                        ...typography.body_500,
                                                        color: palette.primary[500],
                                                        padding: "5px",
                                                        fontWeight: 600,
                                                        marginTop: "15px"
                                                    }}
                                                    onClick={handleDocumentUploadDialogOpen}
                                                    disabled={isLoading || apiLoading}
                                                >
                                                    Upload Documents
                                                </Button>
                                            </Box>
                                        )}
                                    <Box sx={{ background: palette.background.paper, padding: '25px 30px 30px', borderRadius: '20px', display: 'flex', flexDirection: 'column', gap: '35px' }} boxShadow={1}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', maxHeight: '58px' }}>
                                            {isUserLoading ?
                                                <CircularProgress /> :
                                                <Box sx={(theme: Theme) => (
                                                    {
                                                        backgroundColor: theme.palette.primary[100],
                                                        borderRadius: '50%',
                                                        width: '70px',
                                                        height: '58px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }
                                                )}>
                                                    <Typography variant="h1" sx={(theme: Theme) => ({
                                                        letterSpacing: '0.02px',
                                                        color: theme.palette.primary[500]
                                                    })}>{getAbbreviatedName(investorName ?? "")}</Typography>
                                                </Box>
                                            }
                                            <Box width={'100%'}>
                                                {isUserLoading ? <Skeleton variant='text' animation="wave" /> :
                                                    <Typography variant='h2' fontSize={{ sm: '18px', xs: '18px', md: '20px', lg: '20px' }} color={palette.text.primary}>
                                                        {maskInfo(investorName || '')}
                                                    </Typography>
                                                }
                                                <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                    {isUserLoading ? <Skeleton variant='text' animation="wave" /> : <Typography variant='body_500' color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>{isMinor ? "Minor" : userDetails?.status}</Typography>}
                                                    <Box sx={{ borderRadius: '50%', width: '5px', height: '5px', background: palette.text.secondary }} />
                                                    {isUserLoading ? <Skeleton variant='text' animation="wave" />
                                                        :
                                                        <Typography variant="subtitle_500" color={palette.text.secondary}>
                                                            {clientCode}
                                                        </Typography>
                                                    }
                                                </Box>
                                            </Box>
                                        </Box>
                                        {/* {role === USER_ROLES.INVESTOR && (
                                        <Box sx={{ width: '100%', mt: 3 }}>
                                            <FormGroup>
                                                <FormControlLabel
                                                    sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                    control={
                                                        <Checkbox
                                                            size="medium"
                                                            disableRipple
                                                            checkedIcon={<CheckIcon />}
                                                            icon={<UnCheckIcon />}
                                                            sx={{
                                                                padding: 0,
                                                                '&:hover': {
                                                                    backgroundColor: 'transparent',
                                                                },
                                                            }}

                                                            onChange={() => setIsTxnDialog(true)}
                                                            checked={disclaimerChecked}
                                                        />}
                                                    label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                />

                                            </FormGroup>
                                        </Box>
                                    )} */}
                                        {isRMLikeRole(role) &&
                                            <Box width={'100%'}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                    <EmailIcon />
                                                    {isUserLoading ? <Skeleton variant='text' animation="wave" width={'100%'} /> : <Typography variant='body_500' color={palette.text.primary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>{maskInfo(userDetails?.email || '')}</Typography>}
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                    <Phoneicon />
                                                    {isUserLoading ? <Skeleton variant='text' animation="wave" width={'100%'} /> : <Typography variant='body_500' color={palette.text.primary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>{maskInfo(userDetails?.mobile || '')}</Typography>}
                                                </Box>
                                                {/* Disclaimer */}
                                                {isUserLoading ? (
                                                    <Skeleton variant="text" animation="wave" width={'100%'} />
                                                ) : (
                                                    <Box sx={{ width: '100%', mt: 3 }}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                                control={
                                                                    <Checkbox
                                                                        size="medium"
                                                                        disableRipple
                                                                        checkedIcon={<CheckIcon />}
                                                                        icon={<UnCheckIcon />}
                                                                        sx={{
                                                                            padding: 0,
                                                                            '&:hover': {
                                                                                backgroundColor: 'transparent',
                                                                            },
                                                                        }}

                                                                        onChange={() => setIsTxnDialog(true)}
                                                                        checked={disclaimerChecked}
                                                                    />}
                                                                label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                            />

                                                        </FormGroup>
                                                    </Box>
                                                )}
                                            </Box>
                                        }
                                        <Divider />
                                        {/* <Grid container rowGap={{ lg: '35px', md: '25px', sm: '15px', xs: '15px' }}>
                                            <Grid item md={6} lg={6} sm={12} xs={12} sx={{ display: 'flex', flexDirection: { lg: 'column', md: 'column', sm: 'row', xs: 'row' }, justifyContent: { xs: 'space-between', sm: 'space-between', md: 'unset', lg: 'unset' } }}>
                                                <Typography variant='body_500' color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>SWP Amount</Typography>
                                                {schemeLoading ? <Skeleton variant='text' animation="wave" width={'90%'} /> :
                                                    <Typography variant='body_600' fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>{values.amount ? toINR({ value: Number(values.amount), locale, currencyCode }) : "-"}</Typography>
                                                }
                                            </Grid>
                                            <Grid item md={6} lg={6} sm={12} xs={12} textAlign={{ lg: 'right', md: 'right', sm: 'left', xs: 'left' }} sx={{ display: 'flex', flexDirection: { lg: 'column', md: 'column', sm: 'row', xs: 'row' }, justifyContent: { xs: 'space-between', sm: 'space-between', md: 'unset', lg: 'unset' } }}>
                                                <Typography alignSelf={'flex-end'} variant='body_500' color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>SWP Frequency</Typography>
                                                {schemeLoading ? <Skeleton variant='text' animation="wave" width={'100%'} /> :
                                                    <Typography alignSelf={'flex-end'} variant='body_600' fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>{values.frequency ? `Once a 
                        ${values.frequency}` : "-"}</Typography>
                                                }
                                            </Grid>
                                            <Grid item md={6} lg={6} sm={12} xs={12} sx={{ display: 'flex', flexDirection: { lg: 'column', md: 'column', sm: 'row', xs: 'row' }, justifyContent: { xs: 'space-between', sm: 'space-between', md: 'unset', lg: 'unset' } }}>
                                                <Typography variant='body_500' color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>SWP Date</Typography>
                                                {schemeLoading ? <Skeleton variant='text' animation="wave" width={'90%'} /> :
                                                    <Typography variant='body_600' fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>{values.swpDate ? dayjs(values.swpDate).format('DD/MM/YYYY') : "-"}</Typography>
                                                }
                                            </Grid>
                                            <Grid item md={6} lg={6} sm={12} xs={12} textAlign={{ lg: 'right', md: 'right', sm: 'left', xs: 'left' }} sx={{ display: 'flex', flexDirection: { lg: 'column', md: 'column', sm: 'row', xs: 'row' }, justifyContent: { xs: 'space-between', sm: 'space-between', md: 'unset', lg: 'unset' } }}>
                                                <Typography alignSelf={'flex-end'} variant='body_500' color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>No. of Installments</Typography>
                                                {schemeLoading ? <Skeleton variant='text' animation="wave" width={'100%'} /> :
                                                    <Typography alignSelf={'flex-end'} variant='body_600' fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>{values.installment ? values.installment : "-"}</Typography>
                                                }
                                            </Grid>
                                            <Grid item md={6} lg={12} sx={{ display: 'flex', flexDirection: { lg: 'column', md: 'column', sm: 'row', xs: 'row' }, justifyContent: { xs: 'space-between', sm: 'space-between', md: 'unset', lg: 'unset' } }}>
                                                <Typography variant='body_500' color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>Bank</Typography>
                                                {schemeLoading ? <Skeleton variant='text' animation="wave" width={'100%'} /> :
                                                    <Typography variant='body_600' fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>
                                                        {selectedBankDetails(values.bankType)}
                                                    </Typography>
                                                }
                                            </Grid>
                                        </Grid> */}
                                        <Hidden lgUp>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    columnGap: "10px"
                                                }}
                                            >
                                                <Typography
                                                    variant="subtitle_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "14px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    Total Amount
                                                </Typography>
                                                <Typography
                                                    variant="h2"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "25px",
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {toINR({
                                                        value: (TotalValue()),
                                                        locale,
                                                        currencyCode
                                                    })
                                                    }
                                                </Typography>
                                            </Box>
                                        </Hidden>
                                        <Hidden lgDown >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    rowGap: "10px"
                                                }}
                                            >
                                                <Typography
                                                    variant="h3"
                                                    sx={(theme: Theme) => ({
                                                        fontSize: "32px",
                                                        lineHeight: "40px",
                                                        color: theme.palette.text.primary
                                                    })}
                                                >
                                                    {toINR({
                                                        value: (TotalValue()),
                                                        locale,
                                                        currencyCode
                                                    })
                                                    }
                                                </Typography>
                                                <Typography
                                                    variant="body_500"
                                                    sx={(theme: Theme) => ({
                                                        lineHeight: "16px",
                                                        color: theme.palette.text.secondary
                                                    })}
                                                >
                                                    Total Amount
                                                </Typography>
                                            </Box>
                                        </Hidden>
                                        {isRMLikeRole(role) && (!isLoading) && mfTxnStatus && (
                                            <Typography variant="overline_600" sx={(theme: Theme) => ({ mt: 2, color: theme.palette.error[500] })} >
                                                You are not allowed to place any transactions as your transaction status is still not active.
                                            </Typography>
                                        )}
                                        {role === USER_ROLES.INVESTOR && (
                                            <>
                                                {/* Disclaimer */}
                                                {(isLoading || apiLoading) ? (
                                                    <Skeleton variant="text" animation="wave" width={'100%'} />
                                                ) : (
                                                    <Box sx={{ width: '100%', mt: 3 }}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                                control={
                                                                    <Checkbox
                                                                        size="medium"
                                                                        disableRipple
                                                                        checkedIcon={<CheckIcon />}
                                                                        icon={<UnCheckIcon />}
                                                                        sx={{
                                                                            padding: 0,
                                                                            '&:hover': {
                                                                                backgroundColor: 'transparent',
                                                                            },
                                                                        }}

                                                                        onChange={() => setIsTxnDialog(true)}
                                                                        checked={disclaimerChecked}
                                                                    />}
                                                                label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                            />

                                                        </FormGroup>
                                                    </Box>
                                                )}
                                            </>
                                        )}
                                        <Box sx={{ display: 'flex', gap: '15px', flexDirection: 'row' }}>
                                            {isRMLikeRole(role) &&

                                                <>
                                                    <CustomeButton lookType={'outlined'} btnText={'Recommend'} disabled={
                                                        // !dirty ||
                                                        schemeLoading ||
                                                        apiLoading ||
                                                        (formRef?.current?.values?.fund ?? []).length === 0 ||
                                                        (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                            isRMLikeRole(role) &&
                                                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                                        )
                                                    } onClick={() => {
                                                        setOrderType('recomment')
                                                        handleSubmit()
                                                    }} />
                                                    <CustomeButton lookType={'contained'} btnText={'Place Order'} disabled={
                                                        // !dirty ||
                                                        schemeLoading ||
                                                        apiLoading ||
                                                        riskPflChkLoading ||
                                                        (formRef?.current?.values?.fund ?? []).length === 0 ||
                                                        (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                            isRMLikeRole(role) &&
                                                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                            MPOWER_ACCOUNT_TYPE_MASTER["ADV"]
                                                        ) || !disclaimerChecked || mfTxnStatus
                                                    } isLoading={riskPflChkLoading} onClick={() => {
                                                        setOrderType('order')
                                                        handleSubmit()
                                                    }} />
                                                </>
                                            }
                                            {role === USER_ROLES.INVESTOR && (
                                                <>
                                                    <CustomeButton lookType={'outlined'} btnText={'Add to Cart'}
                                                        isLoading={addtoCartLoading}
                                                        disabled={
                                                            // !dirty ||
                                                            isLoading ||
                                                            apiLoading ||
                                                            (formRef?.current?.values?.fund ?? []).length === 0
                                                        }
                                                        onClick={() => {
                                                            setOrderType('investor')
                                                            // formik.handleSubmit()
                                                        }}
                                                    />
                                                    <CustomeButton lookType={'contained'} btnText={'Place Order'}
                                                        isLoading={apiLoading || riskPflChkLoading}
                                                        disabled={
                                                            // (details?.investmentDetails?.length || 0) === 0 ||
                                                            ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                            isLoading ||
                                                            (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                isRMLikeRole(role) &&
                                                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                MPOWER_ACCOUNT_TYPE_MASTER["ADV"]
                                                            ) || !disclaimerChecked || mfTxnStatus
                                                        }
                                                        // disabled={selectedSchemes.length === 0 || isLoading || riskPflChkLoading}
                                                        onClick={async () => {
                                                            setOrderType('order')
                                                            // handleSubmit()
                                                            // formik.handleSubmit()
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                            <ConfirmRecomment
                                isLoading={apiLoading}
                                open={confirmRecomment}
                                setClose={setConfirmRecomment}
                                title={orderType === 'recomment' ? "Confirm Recommendation!" : orderType === 'order' ? "Confirm!" : ''}
                                desc={orderType === 'recomment' ? "Are you sure you want to continue with this action ? You can see your old recommendations under recent recommendation tab." : "Are you sure you want to continue with this action ?"}
                                handleConfirm={() => orderType === 'recomment' ? handleConfromRecomment(values) : orderType === 'order' && handleConformOrder(values)}
                            />
                            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} handleConfirmOrder={() => handleConformOrder(values)} isLoading={apiLoading} text={riskPopupText} />
                        </Box>
                        {/* Document Upload Dialog Start */}
                        <TransactionsDocumentUpload
                            open={isDocumentUploadDialogVisible}
                            onClose={handleDocumentUploadDialogClose}
                        />
                        {/* Document Upload Dialog End */}

                        {/* Multiple Orders from the same scheme/folio combination Dialog start */}
                        <ConfirmRecomment
                            open={isSameSchemesDialogOpen}
                            setClose={handleSameSchemeDialogClose}
                            title="Confirm!"
                            desc="Multiple Orders with the same scheme/folio combination. Please confirm before proceeding."
                            handleConfirm={handleSameSchemeDialogConfirm}
                        />
                        {/* Multiple Orders from the same scheme/folio combination Dialog end */}
                    </>
                )
            }}
        </Formik>


        {cartPopup &&
            <AddtoCardPopup open={cartPopup} setClose={setCartPopup} handleSuccess={handleSuccess} />}
        <SuccessModal
            open={successModal}
            setClose={setSuccessModal}
            onclick={handleSuccessPopup}
            title="Success!"
            confirmBtnText={"Go to Dashboard"}
            // desc={orderType === 'recomment' ? "The recommended schemes will be sent to the investor." : "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."}
            desc={successMessage ?? ""}
        />
        <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={handleCloseFiveSchemesDialog} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
        <ValidateDialogBox handleValidationDialogClose={handleValidationDialogClose} validationErrorsArray={validationErrorsArray} isValidationDialogVisible={isValidationDialogVisible} />
        {/* Document Upload Error Dialog Start */}
        <Dialog
            aria-labelledby="error-dialog"
            open={isDocumentUploadErrorDialogVisible}
            PaperProps={{
                sx: {
                    maxWidth: '550px',
                    width: "100%",
                    borderRadius: "12px",
                    padding: "24px",
                    backgroundColor: palette.common.white
                },
            }}
        >
            <DialogContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    rowGap: "12px",
                    padding: "15px",
                    overflow: "hidden"
                }}
            >
                <FailureIcon width="35" height="35" />
                <Typography
                    variant="h2"
                    sx={{
                        lineHeight: "25px",
                        letterSpacing: "0.01px",
                        color: palette.text.primary
                    }}
                >
                    Error!
                </Typography>
                <Typography
                    variant="subtitle_400"
                    sx={{
                        lineHeight: "22px",
                        letterSpacing: "0.02px",
                        color: palette.text.secondary,
                        textAlign: "center",
                        paddingLeft: "10px",
                        paddingRight: "10px"
                    }}
                >
                    Please upload minimum 1 document
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    padding: "0px",
                    marginTop: "40px",
                }}
            >
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleDocumentUploadErrorDialogClose}
                    sx={{
                        ...typography.body_500,
                        fontWeight: 600,
                        lineHeight: "20px",
                        color: palette.common.white,
                        borderRadius: "4px",
                        padding: "13px 20px",
                        backgroundColor: palette.primary[500]
                    }}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
        {/* Document Upload Error Dialog End */}

        {/* Transaction Disclaimer Popup */}

        <TransactionsDisclaimerText
            handleDialogClose={() => {
                setIsTxnDialog(false);
                setDisclaimerChecked(true);
            }}
            isDialog={isTxnDialog}
        />

        {/* Add More Funds start */}
        {isAddMoreHoldingDialogOpen && (
            <HoldingFundMore
                {...{
                    open: isAddMoreHoldingDialogOpen,
                    setOpen: setAddMoreHoldingDialogOpen,
                    clientCode,
                    holdingsData,
                    setHoldingsData,
                    handleProceed,
                }}
            />
        )}
        {/* Add More Funds end */}
    </>
}

export default Swp